import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  isLastStep: boolean;
}

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    form: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(0, 2, 2),

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 4, 2),
      },

      [theme.breakpoints.between('md', 'lg')]: {
        paddingBottom: theme.spacing(13),
      },

      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: ({ isLastStep }) => (!isLastStep ? 'left' : 'center'),
      },
    },

    iconContainer: {
      width: '100%',
      textAlign: 'center',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 120,
        filter: 'drop-shadow(0px 5px 10px #21212133)',
      },
    },

    buttonsContainer: {
      marginTop: theme.spacing(4),
      justifyContent: 'center',
      alignItems: 'center',
    },
    button: {
      marginTop: 'unset',
    },
  })
);

export default useStyles;
